import type ClientItem from '../store/schema/ClientItem';
import { getStore } from '../store/Store';
import type ItemId from 'owa-service/lib/contract/ItemId';
import { mutatorAction } from 'satcheljs';

// Sets flag for indicating a draft is queued for submission, i.e. in the state Delay or Sending
export default mutatorAction(
    'setIsDraftQueuedForSubmission',
    (itemId: ItemId, isDraftQueuedForSubmission: boolean) => {
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2322 (13,15): Type 'ClientItem | undefined' is not assignable to type 'ClientItem'.
        // @ts-expect-error
        const item: ClientItem = getStore().items.get(itemId?.Id);
        if (item) {
            item.isDraftQueuedForSubmission = isDraftQueuedForSubmission;
        }
    }
);
